import React from 'react';
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { AppStoreButton, GooglePlayButton } from "react-mobile-app-button";
import BigLogo from "../components/BigLogo";

const MainPage = () => {
    const { t } = useTranslation();

    return (
        <Container className={"pt-5"}>
            <Row className="justify-content-center text-center">
                <Col>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                        <BigLogo/>
                    </div>
                    <h1>{'Gymgress'}</h1>


                    <p>{t('home.description')}</p>


                    <div className="d-flex flex-column gap-3 flex-lg-row justify-content-center align-items-center">
                        <GooglePlayButton
                            url={'https://play.google.com/store/apps/details?id=app.gymgress.gymgress'}
                            theme={"dark"}
                            className={"custom-style"}
                        />
                        <AppStoreButton
                            url={'https://apps.apple.com/es/app/gymgress/id6468820967'}
                            theme={"dark"}
                            className={"custom-style"}
                        />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default MainPage;
